import React, { FC } from 'react';
import { Typography, TypographyProps } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  text: {
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '34px',
    lineHeight: '119%',
    letterSpacing: '0',
    color: theme.palette.text.primary,
    marginTop: 0,
    marginBottom: '15px',
    padding: 0,
  },
}));

export type TitleOfBlockProps = {
  text: string | React.ReactElement;
};

export const TitleOfBlock: FC<TitleOfBlockProps & TypographyProps> = ({
  text,
  className,
  ...props
}) => {
  const { classes, cx } = useStyles();

  return (
    <Typography
      variant="h1"
      className={cx(classes.text, className)}
      {...props}
    >
      {text}
    </Typography>
  );
};
